import { ThemeEvents } from "@theme/events";

/**
 * Keeps Afterpay / Square `square-placement` data-amount in sync with the
 * selected variant on the product page. Mirrors the PDP price, which is also
 * unit-priced (quantity is ignored). Variant price from the theme is in cents.
 *
 * @param {number} priceCents
 */
function formatAmountAttribute(priceCents) {
  const major = priceCents / 100;
  return (Math.round(major * 100) / 100).toString();
}

/**
 * @param {Element} section
 * @param {number} unitPriceCents
 */
function updateAfterpayMessaging(section, unitPriceCents) {
  const placements = section.querySelectorAll("square-placement");
  if (!placements.length) return;

  const amount = formatAmountAttribute(unitPriceCents);

  for (const el of placements) {
    el.setAttribute("data-amount", amount);
  }
}

/**
 * @param {Event} event
 */
const onVariantUpdate = (event) => {
  const picker = event.target;
  if (!(picker instanceof HTMLElement) || picker.tagName !== "VARIANT-PICKER") {
    return;
  }

  const detail = /** @type {import('@theme/events').VariantUpdateEvent} */ (
    event
  ).detail;
  const variant = detail?.resource;
  if (variant == null || typeof variant.price !== "number") return;

  const section = picker.closest(".shopify-section");
  if (!section) return;

  const form = /** @type {HTMLElement | null} */ (
    section.querySelector("product-form-component")
  );
  if (
    form?.dataset.productId &&
    detail?.data?.productId &&
    form.dataset.productId !== detail.data.productId
  ) {
    return;
  }

  updateAfterpayMessaging(section, variant.price);
};

document.addEventListener(ThemeEvents.variantUpdate, onVariantUpdate);
